import React from 'react';
import { v4 as uuid } from 'uuid';

import { Carousel, FormWrapper } from '../../../WidgetConfiguratorComponents/FormGroups';
import defaultState from '../defaultState';
import { EXTREMES_SCOPE } from '../MinimaAndMaxima';
import LineGraphItem from './LineGraphItem';

const DatabilitiesConfigurator = ({ viewblockState, setViewblockState, baseDatability }) => {
    const { databilities, settings } = viewblockState;
    const startOfUnit = settings.truncateNowTo || defaultState.settings.truncateNowTo;
    const onCarouseAddItem = () => {
        const databilityId = uuid();
        const directionalDatabilityId = uuid();
        const newItem = {
            id: uuid(),
            databilityId,
            directionalDatabilityId,
            style: 'line',
            smoothing: 'smooth',
            symbol: 'dot',
            colour: 'black',
            label: 'newLine',
            zOrder: 1,
            unit: null,
            unitLabel: null,
            displayExtremes: false,
            scope: EXTREMES_SCOPE.ABSOLUTE.value,
            highlightMinima: true,
            minimaReference: ['yAxis'],
            minimaHighlightOnTimeline: true,
            highlightMaxima: true,
            maximaReference: ['yAxis'],
            maximaHighlightOnTimeline: true,
            dp: 2,
        };

        const newDatability = {
            ...baseDatability,
            id: databilityId,
            capabilityId: null,
            datasetId: null,
            timeRange: 'P-1D--P5D',
        };

        const newDirectionalDatability = {
            ...baseDatability,
            id: directionalDatabilityId,
            capabilityId: null,
            datasetId: null,
            timeRange: 'P-1D--P5D',
        };

        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...settings,
                items: [...settings.items, newItem],
            },
            databilities: [...databilities, newDatability, newDirectionalDatability],
        }));
    };

    const onDatabilityChange = (item, prevDatability, nextDatability) => {
        setViewblockState((prev) => ({
            ...prev,
            databilities: prev.databilities.map((datability) => {
                if (datability.id === item.directionalDatabilityId)
                    return {
                        ...datability,
                        datasetId: nextDatability.datasetId,
                        interpolationInterval: nextDatability.interpolationInterval,
                        data_structure: nextDatability.data_structure,
                    };
                return datability === prevDatability ? nextDatability : datability;
            }),
        }));
    };

    const onDirectionalCapabilityChange = (item, capabilityId, directionalDatability, datability) => {
        if (!directionalDatability) {
            const directionalDatability = { ...datability, capabilityId, id: uuid() };
            setViewblockState((prev) => {
                return {
                    ...prev,
                    settings: {
                        ...settings,
                        items: settings.items.map((i) => {
                            if (i.id === item.id) {
                                return { ...item, directionalDatabilityId: directionalDatability.id };
                            } else return i;
                        }),
                    },
                    databilities: [...databilities, directionalDatability],
                };
            });
        }
        setViewblockState((prev) => {
            return {
                ...prev,
                databilities: datability
                    ? prev.databilities.map((d) => {
                          if (d.id === item.directionalDatabilityId) {
                              return { ...d, capabilityId, datasetId: d.datasetId && d.datasetId.length > 0 ? d.datasetId : datability.datasetId };
                          }
                          return d;
                      })
                    : [...databilities, datability],
            };
        });
    };

    const onItemDelete = (item) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...settings,
                items: settings.items.filter(({ id }) => id !== item.id),
            },
            databilities: databilities.filter(({ id }) => id !== item.databilityId && id !== item.directionalDatabilityId),
        }));
    };

    const onItemChange = (item) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...settings,
                items: settings.items.map((i) => (i.id !== item.id ? i : item)),
            },
        }));
    };

    const onTimeRangeChange = ({ timeRange, datability }) => {
        const newDatability = {
            ...datability,
            timeRange,
            datasetId: datability.datasetId,
        };

        setViewblockState((prev) => ({
            ...prev,
            databilities: prev.databilities.map((d) => (d.id === newDatability.id ? newDatability : d)),
        }));
    };

    return (
        <FormWrapper>
            <Carousel label='Items' addItem={onCarouseAddItem}>
                {settings.items.map((item) => {
                    const newItem = item.dp !== undefined ? item : { ...item, dp: 2 };
                    const datability = databilities.find(({ id }) => id === newItem.databilityId);
                    if (!datability) {
                        console.log('this should never happen');
                        return <div />;
                    }
                    return (
                        <LineGraphItem
                            key={newItem.id}
                            item={newItem}
                            datability={databilities.find(({ id }) => id === newItem.databilityId)}
                            directionalDatability={databilities?.find(({ id }) => id === newItem.directionalDatabilityId)}
                            onDatabilityChange={onDatabilityChange}
                            onDirectionalCapabilityChange={onDirectionalCapabilityChange}
                            onDelete={() => onItemDelete(newItem)}
                            onChange={onItemChange}
                            onTimeRangeChange={onTimeRangeChange}
                            startOfUnit={startOfUnit}
                        />
                    );
                })}
            </Carousel>
        </FormWrapper>
    );
};

export default DatabilitiesConfigurator;
